import React from 'react';
import SelectField from '../../../../Dropdown/select/SelectField';
var DropdownInput = function (_a) {
    var id = _a.id, label = _a.label, isLabelHidden = _a.isLabelHidden, items = _a.items, wrapperClassName = _a.wrapperClassName, value = _a.value, onSelect = _a.onSelect;
    return (React.createElement(SelectField, { id: id, label: label, isLabelHidden: isLabelHidden, className: wrapperClassName, onSelect: onSelect, items: items, value: value, withBlankOption: false }));
};
DropdownInput.displayName = 'DropdownInput';
export default DropdownInput;
//# sourceMappingURL=DropdownInput.js.map